import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppStoreService } from '../services/app-store.service';

@Injectable({
  providedIn: 'root'
})
export class PreAccessGuard implements CanActivate {
  constructor(
    private router: Router,
    ) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const check = localStorage.getItem('beta');
      if(check) {
        return true;
      } else {
        this.router.navigate(['/beta-access']);
        return false;
      }
    }
}
